
import $ from 'jquery';

/**
 * Custom Scripts
 */
import Form from './custom/forms';
// import SocialMedia from './custom/bjzm-social-feeds';
import BjzmScripts from './custom/bjzm-scripts';
import Slider from './custom/bjzm-slideshow.js';

import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
import HeaderScroll from './custom/header-scroll';
import SinglePageUpdown from './custom/single-page-updown';
import BjzmFormScripts from './custom/bjzm-form-scripts';
import AppWebApiUtilities from './custom/app-web-api-utilities';
import Maps from './custom/bjzm-maps';
import ScrollMagic from 'scrollmagic';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';


/**
 * Vendors
 */
import matchHeight from './vendors/jquery.matchHeight';
import magnificPopup from 'magnific-popup';
import SingleMap from './custom/bjzm-single-map';

jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var RegisterFormScripts = new BjzmFormScripts();
 	new SingleMap();
 	// var WebApiUtilities = AppWebApiUtilities();

	/* SLIDER  */

	let timeline = '';

	if ($('.body-page-home').length > 0 || $('.body-page-about').length > 0){
		let cardWidth = $('.timeline-slider__item').width() * 2;
		let currentPos = 0

		var options = {
			horizontal: 1,
			itemNav: 'centered',
			syncSpeed: 1,
			speed: 600,
			touchDragging: 1,
			scrollBar: ".scrollbar",
			dragHandle: true,
			clickBar: true,
			swingSpeed: 0.5,
			releaseSwing: true
		}
		timeline =  new Sly('.frame', options);

		timeline.on('moveEnd', function () {
			if(this.pos['dest'] == this.pos['end']){
				$('.timeline-slider--buttons__right').addClass('nav-inactive');
				$('.timeline-slider--buttons__left').removeClass('nav-inactive');
			}else if(this.pos['dest'] == 0){
				$('.timeline-slider--buttons__left').addClass('nav-inactive');
				$('.timeline-slider--buttons__right').removeClass('nav-inactive');
			}else{
				$('.timeline-slider--buttons__right').removeClass('nav-inactive');
				$('.timeline-slider--buttons__left').removeClass('nav-inactive');
			}
		});
		$('.timeline-slider--buttons__left').on('click', function(){
			timeline.slideTo(timeline.pos.dest - cardWidth);
		});
		$('.timeline-slider--buttons__right').on('click', function(){
			timeline.slideTo(timeline.pos.dest + cardWidth);
		});

		if($('.body-page-home').length <= 0){
			timeline.init();
		}

	}


	/* SLIDER */


	/* Load More Posts */
	var LoadMorePosts = new BjzmLoadMorePosts({
		query_vars: BJZM_DATA.query_vars,
		ajax_url: BJZM_DATA.ajaxurl,
		max_num_pages: BJZM_DATA.max_num_pages,
		post_loop: $(".bjzm-wrapper__row--blog-posts"),
		template_partial: 'content-full-width-article'
	});

	// new Maps();

	var subMenuScroll = new SinglePageUpdown({
		container: $(".submenu"),
		offset: 130,
		callBack: function() {
			 ThemeScripts.closeMobileMenu()
		}
	});

	/* Homepage Slideshow*/
	// var HomeSlider = new Slider("home_slider", {
	// 	dots: true,
	// 	customPaging : function(slider, i) {
 // 			return '<a href="#" class="slider__dots"></a>';
 // 		}
 // 	});

	$('.scroll-more__text').click(function(){
	    $('html, body').animate({
	        scrollTop: $( $.attr(this, 'href') ).offset().top
	    }, 950);
	    return false;
	});


	/* Header Scroll */
	var MainHeaderScroll = new HeaderScroll({
		header: $(".header--main"),
		threshold: 300,
		class: 'header--collapsed',

	});

    let windowPos = 0;
    let navHidden = '';

	/* MANAGE THE MODAL */
	/* ON OPEN - Perform mobile phone fixes, save nav state
	   ON CLOSE - Maintain the window and nav state as it was
	*/
	$('.team-member__modal').magnificPopup({
 		type: 'inline',
		midClick: true,
		removalDelay: 300,
		modal: true,
		enableEscapeKey: true,
		fixedBgPos: true,
		mainClass: 'mfp-fade mfp-wrap--team-member',
		callbacks: {
			open: function(){
				if ($('header').hasClass('scrolled')){
					navHidden = true;
				}else {
					navHidden = false;
				}
				$('body').addClass('scroll-lock');
				let target = $('.mfp-wrap');
				target.css({top: '0'});
			},
			close: function(){
				$('body').removeClass('scroll-lock');
				window.scrollTo(0, windowPos);
				if (navHidden){
					setTimeout(function(){
						$('.header').addClass('scrolled');
					}, 1);
				}
			}
		}		
	});
	/* MANAGE THE MODAL */

	/*MODIFY ELEMENTS WHEN YOU SCROLL*/
	function scrollActions(){
        let scroll = $(window).scrollTop();
        if (scroll != 0){
        	setTimeout(function(){
 				windowPos = $(window).scrollTop();       		
        	}, 1);
		}
        if($(window).innerWidth() > 1135){

	        if (scroll > 400 && $('.header__clear').length > 0){
	        	$('.header--main').removeClass('header__clear');
	        	$('.header--main').addClass('header__opaque');
	        	
	        	$('.header__logo-light').addClass('hidden');
	        	$('.header__logo-dark').removeClass('hidden');

	        }else if(scroll < 400 && $('.hero-full-width').length > 0){
	        	$('.header--main').addClass('header__clear');
	        	$('.header--main').removeClass('header__opaque');

	        	$('.header__logo-dark').addClass('hidden');
	        	$('.header__logo-light').removeClass('hidden');
	        	
	        }

	        if (scroll > 400){
	        	$('.header--main').height(80);
	        	$('.header__inner').height(80);
	        	$('.header__navigation').height(80);
	        	$('.navigation__link').css({padding: '30px 0'});

	        }else if (scroll < 400 ){
	        	$('.header--main').height(137);
	        	$('.header__inner').height(137);
	        	$('.header__navigation').height(137);
	        	$('.navigation__link').css({padding: '37px 0'});
	        }
	    }else{
	        	$('.header--main').height(70);
	        	$('.header__inner').height(38);
	        	$('.header__navigation').height(70);
	        	$('.navigation__link').css({padding: '19px 0 13px 0'});	    	
	    }


        if ($('.body-page-investor-relations').length > 0){
	        let camembertTarget = $('.camembert').offset().top;
	        let barTarget = $('.bar').offset().top
	        
        	if(scroll > camembertTarget - 400){
        		$('.camembert').addClass('do-animations');
        	}
        	if(scroll > barTarget - 400){
        		$('.bar').addClass('do-animations');
        	}
	    }
	}

	$(window).scroll(function(){
		scrollActions();
	});
	/* MODIFY ELEMENTS WHEN YOU SCROLL */

	/* HERO STUFF */

	// function chkScreen(){
	// 	let chkScreen =  $(window).width() >= 1136 ? 'desktop' : 'mobile';

	// 	return chkScreen;
	// }

	// $(window).resize(function(){
	// 	if (chkScreen() === 'desktop'){
	// 		$('.hero__image').height($(window).height());
	// 		$('.hero__background-outer').height($(window).height());			
	// 	}
	// });

	// if (chkScreen() === 'desktop'){
	// 	$('.hero__image').height($(window).height());
	// 	$('.hero__background-outer').height($(window).height());			
	// } else {
	// 	$('.hero__image').height($(window).height() - 70);
	// 	$('.hero__background-outer').height($(window).height() - 70);	
	// }

	/* HERO STUFF */

	if($('.projectcard').length){
		let $filters = $('.projectcard__filter');
		let $parent = $('.projectcard-sections');
		let $children = $('.projectcard-section');
		let isActive = false;
		let delay = 450;

		$filters.on('click', (e) => {

			if (!isActive){
				isActive = true;
				let $target = $(e.currentTarget)
				let filter = $target.data('filter');

				if($target.hasClass('active')){
					isActive = false;
					return false;
				}

				$filters.removeClass('active');
				$target.addClass('active');

				$parent.addClass('animating');

				setTimeout(()=>{
					$parent.removeClass('animating');
					isActive = false;
				}, delay);

				if(filter == 'all') {
					setTimeout(()=>{
						$children.removeClass('inactive');
						$children.removeClass('active');
						$children.addClass('active');
					}, delay / 2);
				} else {
					let activeCategory = $(`[data-category="${filter}"]`);

					setTimeout(()=>{
						$children.removeClass('inactive');
						$children.removeClass('active');

						$children.addClass('inactive');

						activeCategory.removeClass('inactive');
						activeCategory.addClass('active');
					}, delay / 2);		
				}
			}
		})

		$filters.on('keydown', (e) => {
			if(e.keycode == 13){
				$(e.currentTarget).trigger('click');
			}
		})
	}

	if($('.home-card').length) {
		let count = 0;
		let $cards = $('.home-card--interactive__inner');

		let card_loop = setInterval(()=>{
			let $current = $($cards[count]);
			let $next = $($cards[(($cards.length + (count + 1)) % $cards.length)]);

			$current.removeClass('active');
			$current.addClass('transition');

			$next.removeClass('inactive');
			$next.addClass('active');

			setTimeout(() => {
				$current.removeClass('transition');
				$current.addClass('inactive');
			}, 600);

			count = (($cards.length + (count + 1)) % $cards.length);
		}, 3000)
	}

	scrollActions();
});









